export default __webpack_public_path__ + "static/media/img-csv.77d73fb0.svg";